const NewsList2021 = [
    {
        dt: "2021",
        my: "",
        link: "https://www.thehindu.com/news/national/andhra-pradesh/iit-tirupati-ties-up-with-hindustan-shipyard/article66040687.ece",
        title: "MoU with M/S Hindustan Shipyard Limited",
        desc: ""
    },
    {
        dt: "2021",
        my: "",
        link: "#griha",
        title: "GRIHA COUNCIL - Exemplary Performance Award",
        desc: ""
    },
    {
        dt: "2021",
        my: "",
        link: "https://iittp.ac.in/articles-by-prof-raghuramaraju",
        title: "Articles by Prof. Raghurama Raju",
        desc: ""
    },
    {
        dt: "2021",
        my: "",
        link: "https://rashtragaan.in/",
        title: "Azadi Ka Amrit Mahotsav - rendering of the National Anthem of India",
        desc: ""
    },
    {
        dt: "2021",
        my: "",
        link: "#phd",
        title: "PhD Final Defense - Ms. Peraka Naga Siva Pavani",
        desc: ""
    }
];


export default NewsList2021;